<template>
  <div className="filter">
    <el-date-picker
      v-model="value"
      :readonly="readonly"
      :type="type"
      :value-format="valueFormat"
      :default-time="defaultTime"
      @change="filter"
    />
  </div>
</template>

<script>
export default {
  name: 'RestListFilterDateRange',

  inject: ['restList'],

  props: {
    prop: {
      required: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    datePickerProps: {
      type: Object,
      required: false
    },

    defaultValue: {
      required: false
    }
  },

  data() {
    return {
      value: ''
    }
  },

  mounted() {
    if (
      this.defaultValue &&
      this.defaultValue.split(',')[0] &&
      this.defaultValue.split(',')[1]
    ) {
      this.value = [
        this.defaultValue.split(',')[0],
        this.defaultValue.split(',')[1]
      ]
      this.restList.filterField(this.prop, this.value.toString())
    }
  },

  computed: {
    type() {
      if (this.datePickerProps.type) {
        return this.datePickerProps.type
      }
    },

    defaultTime() {
      if (this.datePickerProps.defaultTime) {
        return this.datePickerProps.defaultTime
      }
    },

    valueFormat() {
      if (this.datePickerProps.value_format) {
        return this.datePickerProps.value_format
      }
    }
  },

  methods: {
    filter() {
      let value = this.value ? this.value.join(',') : null
      this.restList.filterField(this.prop, value)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterDateRange.vue